<sc-padding class="no-field-space" *ngIf="!clientStatusService.isMobile">
  <app-service-response [responseMessages]="responseMessages"></app-service-response>
  <sc-flex>
    <sc-button (click)="cancelAction()" [disabled]="!cancelAllowed" iconClass="fa-times"
      dictionaryKey="tmc-yard.ui.control.sac-client.station-transport-details.action.cancel">
    </sc-button>
    <sc-content-spacer grow></sc-content-spacer>
    <sc-button (click)="handlePreviousProcessingStatus()" *ngIf="isBackwardStatusButtonVisible"
      [disabled]="!changeProcessingStatusAllowed" iconClass="fa-chevron-left"
      [dictionaryKey]="backwardStatusButtonDictionaryKey">
    </sc-button>
    <ng-container *ngIf="isForwardStatusButtonVisible">
      <sc-content-spacer></sc-content-spacer>
      <sc-button (click)="handleNextProcessingStatus()" iconPosition="right"
        [disabled]="!changeProcessingStatusNextAllowed || !changeProcessingStatusAllowed" iconClass="fa-chevron-right"
        [dictionaryKey]="forwardStatusButtonDictionaryKey">
      </sc-button>
    </ng-container>
    <ng-container *ngIf="isConfirmButtonVisible">
      <sc-content-spacer></sc-content-spacer>
      <div>
        <sc-flex>
          <div class="options"
            *ngIf="station.stationUsage.routingOptions != null && station.stationUsage.routingOptions.length > 0">
            <mat-form-field appearance="fill">
              <mat-label>
                <sc-dictionary-label dictionaryKey="tmc-yard.common.action.finish"></sc-dictionary-label>
              </mat-label>
              <mat-select [(value)]="station.stationUsage.selectedOption"
                [disabled]="station.stationUsage.routingOptions.length === 0">
                <mat-option *ngFor="let option of station.stationUsage.routingOptions" [value]="option">
                  <span class="transport-options" [ngClass]="getStyles(option)">
                    <ng-container *ngIf="option.dictionaryKey">
                      <sc-dictionary-label [dictionaryKey]="option.dictionaryKey"></sc-dictionary-label>
                    </ng-container>
                    {{ option.label }}
                  </span>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <sc-content-spacer></sc-content-spacer>
          <sc-confirm-button (click)="confirmOptions()" [disabled]="isConfirmOptionsDisabled"></sc-confirm-button>
        </sc-flex>
      </div>
    </ng-container>
  </sc-flex>
</sc-padding>

<div class="no-field-space mobile" *ngIf="clientStatusService.isMobile">
  <sc-flex vertical stretchContent>

    <sc-content-spacer vertical></sc-content-spacer>

    <ng-container *ngIf="isBackwardStatusButtonVisible">
      <sc-button (click)="handlePreviousProcessingStatus()" [disabled]="!changeProcessingStatusAllowed"
        iconClass="fa-chevron-left" [dictionaryKey]="backwardStatusButtonDictionaryKey">
      </sc-button>
      <sc-content-spacer vertical></sc-content-spacer>
    </ng-container>

    <ng-container *ngIf="isForwardStatusButtonVisible">
      <sc-button mat-flat-button (click)="handleNextProcessingStatus()" iconPosition="right"
        [disabled]="!changeProcessingStatusNextAllowed || !changeProcessingStatusAllowed"
        [dictionaryKey]="forwardStatusButtonDictionaryKey" iconClass="fa-chevron-right">
      </sc-button>
      <sc-content-spacer vertical></sc-content-spacer>
    </ng-container>

    <ng-container *ngIf="isConfirmButtonVisible">

      <mat-form-field appearance="fill"
        *ngIf="station.stationUsage.routingOptions != null && station.stationUsage.routingOptions.length > 0">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc-yard.common.action.finish"></sc-dictionary-label>
        </mat-label>
        <mat-select [(value)]="station.stationUsage.selectedOption"
          [disabled]="station.stationUsage.routingOptions.length === 0">
          <mat-option *ngFor="let option of station.stationUsage.routingOptions" [value]="option">
            <span class="transport-options" [ngClass]="getStyles(option)">
              <ng-container *ngIf="option.dictionaryKey">
                <sc-dictionary-label [dictionaryKey]="option.dictionaryKey"></sc-dictionary-label>
              </ng-container>
              {{ option.label }}
            </span>
          </mat-option>
        </mat-select>
      </mat-form-field>

      <sc-content-spacer vertical></sc-content-spacer>

      <sc-confirm-button (click)="confirmOptions()" [disabled]="isConfirmOptionsDisabled"></sc-confirm-button>

      <sc-content-spacer vertical></sc-content-spacer>

    </ng-container>

    <sc-content-spacer vertical></sc-content-spacer>



    <sc-content-spacer vertical [double]="true"></sc-content-spacer>

    <sc-button mat-stroked-button (click)="cancelAction()" [disabled]="!cancelAllowed" iconClass="fa-times"
      dictionaryKey="tmc-yard.ui.control.sac-client.station-transport-details.action.cancel">
    </sc-button>

    <sc-content-spacer vertical [double]="true"></sc-content-spacer>



    <sc-content-spacer vertical [double]="true"></sc-content-spacer>

    <div class="functions">

      <app-transport-details-dialog-action [transport]="transport"
        [disabled]="!station.stationUsage.transportDetailsAllowed" [asButton]="true" (onChange)="handleChange()">
      </app-transport-details-dialog-action>
      <app-link-transport-dialog-action [transportId]="transport?.id"
        [disabled]="!station.stationUsage.transportDetailsAllowed" [asButton]="true" (onChange)="handleChange()">
      </app-link-transport-dialog-action>
      <app-attach-detach-transport-dialog-action [transport]="transport" [asButton]="true" (onChange)="handleChange()">
      </app-attach-detach-transport-dialog-action>
      <app-resend-message-action [transport]="transport" [station]="station"
        [disabled]="!station.stationUsage.umbrueckenAllowed" [asButton]="true">
      </app-resend-message-action>

    </div>

  </sc-flex>
</div>
